var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
export var makeRequest = function (requestHeader, url, method, data) {
    var headers = new Headers(__assign(__assign({}, requestHeader), { "Content-Type": "application/json" }));
    var requestData = {
        method: method !== null && method !== void 0 ? method : "GET",
        mode: "cors",
        cache: "no-cache",
        credentials: "same-origin",
        redirect: "follow",
        referrerPolicy: "no-referrer",
        headers: headers,
    };
    if (data) {
        requestData.body = JSON.stringify(data);
    }
    return fetch(url, requestData)
        .then(function (response) {
        return response.json();
    })
        .then(function (responseData) {
        return responseData;
    })
        .catch(function (error) { return console.warn(error); });
};
